<template>
  <div id="AntagningsstatistikSearch" class="AstaSearch" role="search" aria-label="Sök i antagningsstatistik">
    <div class="container">
      <form class="AstaForm" autocomplete="off" :action="decodeURIComponent(settings?.resultatsida)" method="get" role="search">
        <div class="AstaSearchForm">
          <div class="select-container">
            <select v-model="selectedTerm" class="SearchSelect" :aria-label="settings?.altText" name="astasearchperiod" v-on:focus="hideSuggestions">
              <option v-for="term in terms" :key="term.value" :value="term.value">{{ term.label }}</option>
            </select>
            <Svgicon iconName="triangel-pil-ned"></Svgicon>
          </div>
          <OnClickOutside @trigger="onClickOutsideHandler" class="search-container">
            <Svgicon iconName="forstoringsglas"></Svgicon>
            <input
              v-model="searchQuery"
              class="SearchField"
              type="text"
              name="astasearchfor"
              data-toggle="tooltip"
              data-trigger="hover"
              data-placement="bottom"
              :data-original-title="settings?.searchHoverText"
              :placeholder="settings?.placeHolder"
              :aria-label="settings?.helptextinput"
              :title="settings?.searchHoverText"
              @input="onInput"
            />
            <button @click="clearSearch" aria-label="Rensa sökord" type="button" class="clear-button" :class="searchQuery.length > 0 ? 'show' : ''">
              <Svgicon iconName="kryss"></Svgicon>
            </button>
            <div v-show="suggestions.length > 0" class="SearchSuggestions">
              <div v-for="suggestion in suggestions" :key="suggestion.ord" class="card">
                <a :href="getSuggestionLink(suggestion)">
                  <span class="nyckelord" v-html="highlightSearch(suggestion.ord)"></span>
                  <span class="kategori" v-html="highlightSearch(suggestion.kategori)"></span>
                </a>
              </div>
              <button class="finalCard" type="submit">Visa alla resultat</button>
            </div>
          </OnClickOutside>
          <input type="hidden" v-model="selectedCategory" />
          <button class="SearchButton" type="submit" v-on:focus="hideSuggestions">Sök</button>
        </div>
      </form>
    </div>
  </div>
</template>
<script lang="ts">
  import Svgicon from '../components/svgicon.vue';
  import { OnClickOutside } from '@vueuse/components';
  import { useDebounceFn } from '@vueuse/core';

  /*type AstaSearchProps = {
settings: {
    searchApiAdress: string;
    searchSuggetionSize: string;
    resultatsida: string;
    searchterm: string;
    searchFor: string;
    searchCategory: string;
    terminer: string[];
    altText: string;
    placeHolder: string;
    searchHoverText: string;
    helptextinput: string;
};
};*/
  type SearchResult = {
    antalObjekt: number;
    data: AstaSuggestionResultItemType[];
  };
  type AstaSuggestionResultItemType = {
    ord: string;
    kategori: string;
  };

  export default {
    name: 'AstaSearch',
    components: {
      Svgicon,
      OnClickOutside,
    },
    mounted() {
      this.selectedTerm = this.settings?.searchterm || 'HT25';
      this.searchQuery = this.settings?.searchFor || '';
      this.selectedCategory = this.settings?.searchCategory || '';
      if ((this.settings?.terminer ?? []).length > 0) {
        this.terms = [];
        let terminer = this.settings?.terminer as string[];
        terminer.forEach((element) => {
          let label = '';
          switch (element.substring(0, 2)) {
            case 'HT':
              label = 'Hösten 20' + element.substring(2);
              break;
            case 'ST':
              label = 'Sommar 20' + element.substring(2);
              break;
            case 'VT':
              label = 'Våren 20' + element.substring(2);
              break;
          }
          this.terms.push({ value: element, label: label });
        });
      }
    },
    props: {
      settings: {
        type: Object,
        required: false,
      },
    },
    data() {
      return {
        selectedTerm: 'ST25',
        searchQuery: '',
        selectedCategory: '',
        terms: [
          { value: 'HT25', label: 'Hösten 2025' },
          { value: 'ST25', label: 'Sommar 2025' },
          { value: 'VT25', label: 'Våren 2025' },
        ],
        suggestions: [] as AstaSuggestionResultItemType[],
        currentSearchId: '',
      };
    },
    methods: {
      hideSuggestions() {
        this.suggestions = [];
      },
      onClickOutsideHandler() {
        this.suggestions = [];
      },
      async fetchSuggestions() {
        const response = await fetch(
          decodeURIComponent(this.settings?.searchApiAdress) +
            `/api/antagningsstatistik/suggest?searchfor=${this.searchQuery}&searchterm=${this.selectedTerm}&pagesize=` +
            this.settings?.searchSuggetionSize,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        const data = await response.json();
        if (!data || !data.data) {
          this.suggestions = [];
          return;
        }
        let result: SearchResult = data;
        this.suggestions = result.data.map((item: AstaSuggestionResultItemType) => {
          return {
            ord: item.ord,
            kategori: item.kategori,
          };
        });
        console.error('fetchSuggestions suggestions', JSON.stringify(this.suggestions));
      },
      onInput() {
        //Om fönstret är mindre än 480px så hämta inte förslag
        if (window.innerWidth <= 480) {
          return;
        }
        //Minst 4 tecken
        if (this.searchQuery.length < 4) {
          this.suggestions = [];
          return;
        }
        //Hämta inte om antal att hämta är 0 eller tomt
        if (this.settings?.searchSuggetionSize === '0' || this.settings?.searchSuggetionSize === '') {
          return;
        }
        //Hämta inte genast utan vänta 400ms innan sökningen görs
        //Om sökningen görs igen så avbryt den förra sökningen
        var searchId = this.currentSearchId + 1;
        this.currentSearchId = searchId;
        useDebounceFn(() => {
          if (searchId !== this.currentSearchId) {
            return;
          }
          this.fetchSuggestions();
        }, 400)();
      },
      clearSearch() {
        this.searchQuery = '';
        this.suggestions = [];
      },
      getSuggestionLink(suggestion: AstaSuggestionResultItemType) {
        return (
          decodeURIComponent(this.settings?.resultatsida) +
          `/?astasearchfor=${suggestion.ord}&astasearchperiod=${this.selectedTerm}&astasearchcategory=${suggestion.kategori}`
        );
      },
      highlightSearch(text: String) {
        const regex = new RegExp(`(${this.searchQuery})`, 'gi');
        return text.replace(regex, '<span class="highlighted">$1</span>');
      },
      viewAllResults() {
        // Logic to view all results
      },
    },
  };
</script>
